import { UrlObject } from "url";

export const baseUrl: UrlObject = new URL('https://www.googleapis.com/youtube/v3');